// app/javascript/pages/auth/Login.tsx
import { useForm } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

interface LoginProps {
  errors?: Record<string, string>
}

export default function Login({ errors }: LoginProps) {
  const form = useForm({
    email_address: "",
    password: "",
  })

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    form.post("/session")
  }

  return (
    <div className="flex min-h-screen items-center justify-center">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle>Log in</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email_address">Email</Label>
              <Input
                id="email_address"
                type="email"
                value={form.data.email_address}
                onChange={(e) => form.setData("email_address", e.target.value)}
              />
              {errors?.email_address && (
                <p className="text-sm text-destructive">{errors.email_address}</p>
              )}
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={form.data.password}
                onChange={(e) => form.setData("password", e.target.value)}
              />
            </div>
            <Button type="submit" className="w-full" disabled={form.processing}>
              Log in
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}